export const SnackbarContainer = ({ children }) => {
  return (
    <div aria-live="polite" aria-atomic="true" className="snackbar-container">
      <div className="inner">
        {children}
      </div>
    </div>
  );
};
